export const mapFiltersToSearchParamString = (selectedFilters) => {
  let params = "";
  let firstParam = true;

  selectedFilters.forEach(filter => {
    if (!firstParam) {
      filter = "+" + filter;
    }
    params += filter;
    firstParam = false;
  });

  return params;
};

/**
 * Formats a price value to a currency string with dollar sign and two decimal places
 * @param {number|string|null|undefined} price - The price to format
 * @returns {string} Formatted price string (e.g., "$50.00") or empty string if invalid
 */
export const formatPrice = (price) => {
  if (price === null || price === undefined || price === "") {
    return "";
  }
  if (typeof price === "string") {
    price = parseFloat(price);
  }
  if (isNaN(price)) {
    return "";
  }
  return "$" + price.toFixed(2);
};
